module.exports = __webpack_public_path__ + "static/media/Cats eyes 05_SPANSKA-mixdown.8b5d837e.mp3";